import React, { useEffect, useState, useCallback, useContext } from 'react';
import Select from 'react-select';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { apiGet } from '../../brainApi';
import { QuickAppointmentContext, QuickQuoteContext } from '../../Context';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: '#fdfdfd',
    },
    '& .MuiFormHelperText-contained': {
      display: 'none',
    },
    '& .MuiInputLabel-shrink': {
      display: 'block',
    },
  },
  btnCancel: {
    backgroundColor: '#fdfdfd',
    height: 36,
    marginRight: 10,
    padding: 10,
    color: '#b1b1b1',
  },
  addNewServiceBtn:{
    marginTop:35,
    '& .css-g1d714-ValueContainer': {
      padding:'14px 8px'
    },
    '& .css-1wa3eu0-placeholder':{
      color:'#212B36'
    }
  }
}));

const UnifiedAddService = ({
  record,
  push,
  setServiceOfferings = () => {},
}) => {
  const unifiedVehicleId = record?.vehicle?.vehicle_id;
  const oilCapacities = record?.vehicle?.oil_capacities;
  const { vehicleData: quickAppointmentVehicleData } = useContext(
    QuickAppointmentContext,
  );

  const { vehicleData: quickQuoteVehicleData } = useContext(QuickQuoteContext);

  const classes = useStyles();
  const [services, setServices] = useState(null);
  const [initialSelect, setInitialSelect] = useState(null);
  const [loading, setLoading] = useState(false);

  const getServices = useCallback(() => {
    setLoading(true);
    let vehicleId = null;
    if (quickAppointmentVehicleData?.vehicle_id) {
      // This vehicle ID comes from quick appointment
      vehicleId = quickAppointmentVehicleData.vehicle_id;
    } else if (quickQuoteVehicleData?.vehicle_id) {
      // This vehicle ID comes from quick quote
      vehicleId = quickQuoteVehicleData.vehicle_id;
    } else if (unifiedVehicleId) {
      // This vehicle ID comes from unified appointment
      vehicleId = unifiedVehicleId;
    }
    const params = vehicleId ? { vehicle_id: vehicleId } : null;
    apiGet('/priced-service-offerings', params).then((json) => {
      if (json?.service_offerings.length > 0) {
        const flattenedSOs = json.service_offerings.map((so) => {
          // Bring nested service_offering data up a level
          const flattenedSO = { ...so, ...so.service_offering };
          delete flattenedSO.service_offering;
          return flattenedSO;
        });
        setServices(
          flattenedSOs.sort((a, b) =>
            a.short_name.toLowerCase() > b.short_name.toLowerCase() ? 1 : -1,
          ),
        );
        setLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    getServices();
  }, [getServices]);

  const calculateVehicleOilCost = (service) => {
    if (oilCapacities) {
      const oilCapacity = Math.ceil(Math.min(...oilCapacities));

      const BASE_QUARTS = 5;

      const extraQuarts = Math.max(0, oilCapacity - BASE_QUARTS || 0);
      const extraOilCostDollars =
        (service.extra_oil_cost_per_qt_dollars || 0) * extraQuarts;

      return extraOilCostDollars;
    }
    return 0.0;
  };

  const handleChange = (service_offering) => {
    setServiceOfferings((prev) => [
      ...prev,
      service_offering.service_offering_id,
    ]);

    const newService = {
      ...service_offering,
      display_name: service_offering.short_name,
      status: 'SCHEDULED',
    };

    if (service_offering.add_oil_cost) {
      // If the service requires price adjustment based on oil capacity,
      // adjust the price as required
      const extraOilCostDollars = calculateVehicleOilCost(service_offering);
      newService.parts_cost_dollars += extraOilCostDollars;
      newService.total_cost_dollars += extraOilCostDollars;
    }

    push('newServices', newService);
    setInitialSelect(null);
  };

  return (
    <Grid container spacing={1} className={classes.root}>
      <Grid item md={6} xs={12}>
        {loading || !services ? (
          'Loading...'
        ) : (
          <Select
            placeholder="+ Add New Services"
            classNamePrefix="select"
            options={services}
            getOptionLabel={(option) => option.short_name}
            getOptionValue={(option) => option.service_offering_id}
            onChange={handleChange}
            menuPlacement="auto"
            value={initialSelect}
            className={classes.addNewServiceBtn}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default UnifiedAddService;
